import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import POAMCreate from './AraiManufacturing/Create';
import POPICreate from './PumpSpareInternational/Create';

function PoCreate() {
  const [purchaseenquirytype, setpurchaseenquirytype] = useState('');
  const [purchaseenquirycategory, setpurchaseenquirycategory] = useState('');
  const [purchaseenquirytypeDisabled, setpurchaseenquirytypeDisabled] = useState(false);
  const [purchaseenquirycategoryDisabled, setpurchaseenquirycategoryDisabled] = useState(false);

  const handlepurchaseenquirytypeChange = (event) => {
    const selectedpurchaseenquirytype = event.target.value;
    setpurchaseenquirytype(selectedpurchaseenquirytype);
    setpurchaseenquirycategory('');
    setpurchaseenquirycategoryDisabled(false);
    setpurchaseenquirytypeDisabled(true);

    if (selectedpurchaseenquirytype === 'Manufacturing') {
      setpurchaseenquirycategory('Domestic');
      setpurchaseenquirycategoryDisabled(true);
    }

    if (selectedpurchaseenquirytype === 'Pump Spare') {
      setpurchaseenquirycategory('International');
      setpurchaseenquirycategoryDisabled(true);
    }
  };

  const handlepurchaseenquirycategoryChange = (event) => {
    setpurchaseenquirycategory(event.target.value);
    setpurchaseenquirycategoryDisabled(true);
  };

  const PageDisplay = () => {
    if (purchaseenquirytype === 'Pump Spare' && purchaseenquirycategory === 'International') {
      return <POPICreate />;
    }
    if (purchaseenquirytype === 'Manufacturing') {
      return <POAMCreate />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD PURCHASE ORDER</h6>
          <Link to="/poindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handlepurchaseenquirytypeChange}
                  value={purchaseenquirytype}
                  disabled={purchaseenquirytypeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Tubing category dropdown removed */}

            {purchaseenquirytype === 'Pump Spare' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="International" disabled />
                </Form.Group>
              </Col>
            )}

            {purchaseenquirytype === 'Manufacturing' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PoCreate;
